<template>
    <div>
        <ValidationObserver ref="observer">
            <b-col sm="15" rounded="sm">
                <b-card no-body class="full-width mb-2" border-variant="info">
                    <div slot="header">
                        <span style="font-weight: 700; font-size: medium"
                            >Add Business Plan</span
                        >
                        <router-link to="/businessPlan">
                            <b-button
                                style="float: right; width: 60px"
                                variant="primary"
                                classic="mr-1 btn-primary"
                                class="btn"
                                >Back</b-button
                            >
                        </router-link>
                    </div>
                </b-card>
            </b-col>
            <b-card>
                <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Business Plan Name"
                >
                    <b-row class="my-2 mx-1"
                        ><b-form-input
                            v-model="text1"
                            placeholder="Enter Business Plan Name"
                        ></b-form-input
                    ></b-row>
                    <span class="validate-error" style="color: red">{{
                        errors[0]
                    }}</span>
                </ValidationProvider>

                <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Description."
                >
                    <b-row class="my-2 mx-1">
                        <b-form-textarea
                            id="textarea"
                            v-model="text2"
                            placeholder="Enter Description..."
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea
                    ></b-row>
                    <span class="validate-error" style="color: red">{{
                        errors[0]
                    }}</span>
                </ValidationProvider>
                <ValidationProvider
                    rules="required"
                    v-slot="{ errors, validate }"
                    name="Subscription Logo"
                >
                    <b-row>
                        <b-col md="7" class="ml-2">
                            <b-form-file
                                v-on:change="validate"
                                @change="readLogo"
                                :state="Boolean(selectedFile)"
                                placeholder="Subscription Logo"
                                drop-placeholder="Drop file here..."
                            ></b-form-file>
                        </b-col>
                    </b-row>
                    <span class="validate-error" style="color: red">{{
                        errors[0]
                    }}</span>
                </ValidationProvider>
            </b-card>
            <b-row
                ><b-col md="7">
                    <h3 class="ml-2">Add Subscription</h3>
                </b-col>
                <b-col md="3">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name=" Subscription"
                    >
                        <multiselect
                            class="perm_input"
                            :options="getSubscription"
                            placeholder="Select  Subscription"
                            label="planName"
                            track-by="id"
                            :multiple="false"
                            v-model="feature1"
                        ></multiselect>
                        <span class="validate-error" style="color: red">{{
                            errors[0]
                        }}</span>
                    </ValidationProvider>
                </b-col>
                <b-col md="2"
                    ><b-button
                        :disabled="feature1 == ''"
                        variant="primary"
                        class="add-btn"
                        @click="addPlan1"
                        >Add</b-button
                    >
                    <b-button
                        variant="success"
                        class="refresh-button"
                        @click="reloadData1"
                        :disabled="isLoading1"
                    >
                        <span v-if="isLoading1" class="fa fa-refresh fa-spin" />
                        <span
                            v-else
                            class="fa fa-refresh"
                            aria-hidden="true"
                        ></span></b-button
                ></b-col>
            </b-row>
            <b-table
                :hover="true"
                :items="SubscriptionArray"
                :striped="striped"
                :fields="Column1"
                :dark="false"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive="sm"
                id="my-table"
                :current-page="currentPage"
                :per-page="perPage"
                thead-class="header"
                class="mt-3"
                show-empty
                :busy="loading"
                :no-border-collapse="true"
                @filtered="onFilter"
            >
                <template slot="cell(empty)">
                    <div v-if="isloading1" class="text-center">
                        <span><b>Loading...</b></span>
                    </div>
                    <div v-else class="text-center">No data available.</div>
                </template>
                <template slot-scope="data" slot="cell(action)">
                    <div>
                        <b-button
                            size="sm"
                            class="mr-2 button-circle"
                            @click="onClickDelete(data.index)"
                            variant="danger"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </b-button>
                    </div> </template
            ></b-table>
            <b-row
                ><b-col md="7">
                    <h3 class="ml-2">Add Feature</h3>
                </b-col>
                <b-col md="3">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Feature"
                    >
                        <multiselect
                            class="perm_input"
                            :options="getFeatureList"
                            placeholder="Select Feature"
                            label="name"
                            track-by="name"
                            :multiple="false"
                            v-model="feature2"
                        ></multiselect>
                        <span class="validate-error" style="color: red">{{
                            errors[0]
                        }}</span>
                    </ValidationProvider>
                </b-col>
                <b-col md="2"
                    ><b-button
                        :disabled="feature2 == ''"
                        variant="primary"
                        class="add-btn"
                        @click="addPlan2"
                        >Add</b-button
                    >
                    <b-button
                        variant="success"
                        class="refresh-button"
                        @click="reloadData2"
                        :disabled="isLoading2"
                    >
                        <span v-if="isLoading2" class="fa fa-refresh fa-spin" />
                        <span
                            v-else
                            class="fa fa-refresh"
                            aria-hidden="true"
                        ></span></b-button
                ></b-col>
            </b-row>
            <b-table
                :hover="true"
                :items="addFeatureToTable"
                :striped="striped"
                :fields="Column2"
                :dark="false"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive="sm"
                id="my-table"
                :current-page="currentPage"
                :per-page="perPage"
                thead-class="header"
                class="mt-3"
                show-empty
                :busy="loading"
                :no-border-collapse="true"
                @filtered="onFilter"
            >
                <template slot="cell(empty)">
                    <div v-if="isLoading2" class="text-center">
                        <span><b>Loading...</b></span>
                    </div>
                    <div v-else class="text-center">No data available.</div>
                </template>
                <template slot-scope="data" slot="cell(action)">
                    <div>
                        <b-button
                            size="sm"
                            class="mr-2 button-circle"
                            @click="onClickDelete1(data.index)"
                            variant="danger"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </b-button>
                    </div> </template
            ></b-table>
            <b-pagination
                style="float: right"
                v-model="currentPage"
                :total-rows="filterCount"
                :per-page="perPage"
                prev-text="Prev"
                next-text="Next"
                aria-controls="myHistory"
                hide-goto-end-buttons
            ></b-pagination>
            <b-row class="mt-5">
                <b-col md="6" offset-md="3">
                    <div class="text-center mb-3 mt-3">
                        <button
                            type="button"
                            @click="cancel"
                            class="btn btn-lg btn-danger w-25"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            class="btn btn-lg btn-primary ml-3 w-25"
                            @click="onClickSave"
                        >
                            Save
                        </button>
                    </div>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
export default {
    components: {
        ebSelect,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            feature1: "",
            feature2: "",
            text1: "",
            text2: "",
            text3: "",
            items: [],
            isLoading1: false,
            isLoading2: false,
            SubscriptionArray: [],
            Column1: [
                { label: "PlanName", key: "planName" },
                { label: "description", key: "planDescription" },
                { label: "Plan Price", key: "pricing" },
                { label: "action", key: "action" },
            ],
            Column2: [
                { label: "featureName", key: "name" },
                { label: "description", key: "description" },
                { label: "action", key: "action" },
            ],
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            currentPage: 1,
            perPage: 10,
            filterCount: 0,
            selectedFile: "",
            addFeature: "",
            addFeatureToTable: [],
            selectedFile: null,
        };
    },
    computed: {
        ...mapGetters({
            getFeatureList: "businessPlan/GetfeatureList",
            getSubscriptionList: "businessPlan/GetsubscriptionList",
        }),
        getSubscription() {
            const data = this.getSubscriptionList;
            let newList = [];
            data.map((each) => {
                let arrayObj = {
                    id: each._id,
                    planName: each.planName,
                    planDescription: each.planDescription,
                    pricing: each.pricing.price,
                };
                newList.push(arrayObj);
            });
            return newList;
        },
    },
    methods: {
        ...mapActions({
            fetchFeatureList: "businessPlan/featureList",
            fetchSubscriptionList: "businessPlan/subscriptionPlan",
        }),
        async reloadData1() {
            this.isLoading1 = true;
            await this.fetchSubscriptionList({ scope: "TENANT" });
            this.isLoading1 = false;
        },
        async reloadData2() {
            this.isLoading2 = true;
            await this.fetchFeatureList();
            this.isLoading2 = false;
        },
        addPlan2() {
            if (this.addFeatureToTable.length > 0) {
                if (this.addFeatureToTable.includes(this.feature2)) {
                    this.$toasted.error("Feature Already Added!");
                } else {
                    this.addFeatureToTable.push(this.feature2);
                }
            } else {
                this.addFeatureToTable.push(this.feature2);
            }
        },
        cancel() {
            this.$swal({
                title: "Are you sure?",
                text: "You want to Cancel!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33", // blue
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Cancel!",
                cancelButtonText: "No don't Cancel!",
                closeOnConfirm: false,
                closeOnCancel: false,
            }).then(async (result) => {
                if (result.value) {
                    this.$swal({
                        timer: 1100,
                        title: "Cancelled!",
                        text: "Yes, Cancelled.Please Update...",
                    });
                    (this.text1 = ""),
                        (this.text2 = ""),
                        (this.selectedFile = ""),
                        (this.addFeatureToTable = []),
                        (this.SubscriptionArray = []);
                }
            });
        },
        addPlan1() {
            if (this.SubscriptionArray.length > 0) {
                if (this.SubscriptionArray.includes(this.feature1)) {
                    this.$toasted.error("Subscription Plan Already Added!");
                } else {
                    this.SubscriptionArray.push(this.feature1);
                }
            } else {
                this.SubscriptionArray.push(this.feature1);
            }
        },
        onClickDelete(index) {
            this.$swal({
                title: "Are you sure?",
                text: "You want to delete this Subscription Plan?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.SubscriptionArray.splice(index, 1)
                        .then((result) => {
                            this.$toasted.success(
                                "Subscription Plan Deleted Successfully",
                            );
                        })
                        .catch((error) => {
                            this.$toasted.error(error.message);
                        });
                }
            });
        },
        onClickDelete1(index) {
            this.$swal({
                title: "Are you sure?",
                text: "You want to delete this Feature?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText:"Yes, delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.addFeatureToTable
                        .splice(index, 1)
                        .then((result) => {
                            this.$toasted.success(
                                "Feature Deleted Successfully",
                            );
                        })
                        .catch((error) => {
                            this.$toasted.error(error.message);
                        });
                }
            });
        },
        async onClickSave() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) return;

            if (
                this.SubscriptionArray.length == 0 &&
                this.addFeatureToTable.length == 0
            ) {
                this.$swal({
                    title: "Error",
                    text: "Please fill all required fields.",
                    type: "error",
                });
            } else if (this.SubscriptionArray.length == 0) {
                Vue.toasted.show("Select Subscription Plan", {
                    type: "info",
                    theme: "toasted-primary",
                    singleton: true,
                    duration: 1000,
                });
            } else if (this.addFeatureToTable.length == 0) {
                Vue.toasted.show("Select Feature", {
                    type: "info",
                    theme: "toasted-primary",
                    singleton: true,
                    duration: 1000,
                });
            } else {
                const payload = {
                    planName: this.text1,
                    description: this.text2,
                    image: this.selectedFile,
                    features: this.addFeatureToTable,
                    subscriptions: this.SubscriptionArray,
                    planPriority: 1,
                    scope:
                        this.$store.state.auth?.authentication?.roles?.[0] ===
                        "PARTNER"
                            ? "PARTNER"
                            : "TA",
                };
                await this.$store
                    .dispatch("businessPlan/createBusinessPlan", payload)
                    .then((res) => {
                        if (res.status == 200) {
                            this.$swal({
                                title: "Success",
                                text: "Plan Created Successfully",
                                type: "success",
                                timer: 1000,
                            });
                        }
                    });
                setTimeout(() => {
                    this.$router.push("/businessPlan");
                }, 2000);
            }
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        readLogo(e) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                this.uploadImage(reader.result);
            };
            reader.onerror = (err) => {
                console.error("reader : ", err);
            };
        },
        // upload images to the S3 bucket
        async uploadImage(image) {
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "tenant",
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        this.clearCustomToast();
                        this.selectedFile = res.data.fileUrl;
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000,
            });
        },
        showCustomToast2() {
            Vue.toasted.show("This Plan Already Added", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
    },
    async mounted() {
        await this.fetchFeatureList();
        await this.fetchSubscriptionList({
            scope: "TENANT",
        });
    },
};
</script>
<style>
.refresh-button {
    position: revert;
    margin-left: 5px;
    top: 12px;
    font-size: large;
    z-index: 1;
    right: 15px;
    width: 42px;
    height: 41.5px;
    padding: 0px;
}

.add-btn {
    margin-left: -9px;
    height: 41.5px;
    width: 98px;
}

.feature-select {
    margin-left: 50px;
}

.custom-file-label::after {
    color: #ffffff;
    background-color: #3837d6;
    line-height: 1.2;
}

.custom-file-label {
    line-height: 1.2;
}
.perm_input {
    margin-bottom: 10px;
}
</style>
